import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button.jsx';

export function Pagination({ total, limit, skip, onChange, className = '' }) {
  if (!total || total <= limit) return null;

  const page = Math.floor(skip / limit) + 1;
  const pages = Math.ceil(total / limit);

  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-3 border-t px-5 py-3 ${className}`}
      style={{ borderColor: 'rgb(var(--line-soft))' }}
    >
      <p className="text-xs text-muted">
        <span className="tabular font-medium text-ink-soft">{skip + 1}–{Math.min(skip + limit, total)}</span>
        {' of '}
        <span className="tabular font-medium text-ink-soft">{total}</span>
      </p>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="secondary" icon={ChevronLeft}
          disabled={page <= 1} onClick={() => onChange(Math.max(0, skip - limit))}>
          Previous
        </Button>
        <span className="tabular px-1 text-xs text-muted">{page} / {pages}</span>
        <Button size="sm" variant="secondary" disabled={page >= pages} onClick={() => onChange(skip + limit)}>
          Next <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}

export default Pagination;
